import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { router } from "./router";
import VueMeta from "vue-meta";

import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

import VueGtag from "vue-gtag";

Vue.use(
  VueGtag,
  {
    config: { id: "UA-141548235-8" },
    appName: "Central de Serviços",
    pageTrackerScreenviewEnabled: true
  },
  router
);

import VueCurrencyInput from 'vue-currency-input'

const pluginOptions = {
  globalOptions: {
    currency: 'BRL',
    locale: 'pt-BR',
    precision: 2,
    autoDecimalDigits: true,
    distractionFree: false,
    useGrouping: true        
  }
}

Vue.use(VueCurrencyInput, pluginOptions)

Vue.use(VueMeta, { refreshOnceOnNavigation: true });

import "./registerServiceWorker";

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
